var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content_PressReleaseDetail"},[(_vm.isLoading)?_c('hollow-dots-spinner',{attrs:{"animation-duration":1000,"dot-size":15,"dots-num":3,"color":"#0FD8C9"}}):_vm._e(),_c('h1',[_vm._v(_vm._s(_vm.title))]),_c('span',{domProps:{"innerHTML":_vm._s(_vm.content)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }